var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconMuleDeer = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.26 3c-.14 0-.419 0-.559.28-.14.42-.979 2.377-1.818 4.475-.14.42-.42.7-.84.7-.419 0-.838-.28-1.398-.98-.56-.699-.839-.978-1.119-1.538 0 0-.28-.7-.559-1.538 0-.28-.14-.42-.42-.28-.28.14-.28.28-.28.56.14.699.28 1.678.28 1.678.14.699.42 1.398.84 2.098.14.28.699.979 1.258 1.538.42.42.42.84.42 1.538v2.098c0 1.12-.7 1.12-1.958.98-1.259-.28-1.678-.42-2.238-1.54-.56-1.118-1.818-3.216-3.217-5.593 0-.14-.28-.28-.42-.14-.14 0-.279.28-.14.42 0 0 1.26 3.356 1.959 5.314.14.28 0 .56-.14.7-.42.419-.84.419-1.818.14-1.259-.14-1.399-.28-2.238-.84-.839-.56-1.818-1.259-2.098-1.399-.28-.14-.56 0-.7.14-.139.14 0 .42.14.56.14.14 1.12.839 1.959 1.538 1.259.98 1.818 1.119 3.077 1.539 1.258.42 6.993 1.818 7.832 1.958.84.14 1.399.979.979 1.818l-1.259 2.937 1.958.839s1.259-2.657 1.539-3.217c.56-1.259.42-2.377-.42-3.356-.56-.7-.7-1.399-.14-4.336.28-1.539.28-1.958.84-3.916.559-1.958 1.118-4.196 1.258-4.755-.28-.28-.28-.42-.56-.42z",
    fill: "#1A202C",
    fillRule: "nonzero"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMuleDeer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-mule-deer.8644b6ff.svg";
export { ForwardRef as ReactComponent };